import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=10dfa830&"
import script from "./contextMenu.js?vue&type=script&lang=js&"
export * from "./contextMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports